// import React from "react";
// import { Container, Row, Col, Card, Button } from "react-bootstrap";
// import { FaCheckCircle, FaServer, FaTools, FaTruck, FaShieldAlt, FaCogs } from "react-icons/fa";
// import "aos/dist/aos.css";
// import "../styles/hardware.css"; // You can create a separate CSS if needed

// const EndOfLifeHardwareSupport = () => {
//   return (
//     <div className="telecom-support-section">
//       <Container fluid className="py-5 text-dark">
//         <Container data-aos="fade-up">
//           {/* Hero Section */}
//           <Row className="align-items-center">
//             <Col md={6} data-aos="fade-right">
//               <h3 className="fw-bold mb-3">End-of-Life Hardware Support & Supply</h3>
//               <p className="lead">
//                 Keep your mission-critical infrastructure running smoothly with our End-of-Life (EOL) hardware 
//                 support and supply services. We help businesses extend the life of legacy IT systems by providing 
//                 expert maintenance, repair, and sourcing for discontinued servers, storage, and networking equipment.
//               </p>
//               <ul className="list-unstyled check-list">
//                 <li><FaCheckCircle className="me-2 text-success" /> Global sourcing for rare & legacy components</li>
//                 <li><FaCheckCircle className="me-2 text-success" /> Expert repair & refurbishment services</li>
//                 <li><FaCheckCircle className="me-2 text-success" /> Cost-effective alternatives to full system upgrades</li>
//               </ul>
//             </Col>
//             <Col md={6} data-aos="fade-left">
//               <video
//                 src="/videos/end_of_life_hardware.mp4"
//                 className="network-video mt-4"
//                 autoPlay
//                 loop
//                 muted
//                 playsInline
//               />
//             </Col>
//           </Row>

//           {/* Key Services */}
//           <h4 className="fw-bold text-center mt-5 mb-4">Our Key Services</h4>
//           <Row className="g-4">
//             <Col md={4}>
//               <Card className="service-card h-100" data-aos="zoom-in">
//                 <Card.Body>
//                   <FaServer className="icon" />
//                   <Card.Title>Legacy Hardware Sourcing</Card.Title>
//                   <Card.Text>
//                     Access discontinued servers, storage devices, and networking hardware through our global supplier network.
//                   </Card.Text>
//                 </Card.Body>
//               </Card>
//             </Col>

//             <Col md={4}>
//               <Card className="service-card h-100" data-aos="zoom-in" data-aos-delay="100">
//                 <Card.Body>
//                   <FaTools className="icon" />
//                   <Card.Title>Repair & Refurbishment</Card.Title>
//                   <Card.Text>
//                     Extend the lifespan of your infrastructure with professional repair, refurbishment, and part replacement.
//                   </Card.Text>
//                 </Card.Body>
//               </Card>
//             </Col>

//             <Col md={4}>
//               <Card className="service-card h-100" data-aos="zoom-in" data-aos-delay="200">
//                 <Card.Body>
//                   <FaTruck className="icon" />
//                   <Card.Title>Fast Delivery</Card.Title>
//                   <Card.Text>
//                     Minimize downtime with rapid procurement and delivery of EOL components anywhere in the world.
//                   </Card.Text>
//                 </Card.Body>
//               </Card>
//             </Col>

//             <Col md={4}>
//               <Card className="service-card h-100" data-aos="zoom-in">
//                 <Card.Body>
//                   <FaShieldAlt className="icon" />
//                   <Card.Title>Secure Asset Disposal</Card.Title>
//                   <Card.Text>
//                     Safely retire outdated hardware with certified data destruction and eco-friendly disposal practices.
//                   </Card.Text>
//                 </Card.Body>
//               </Card>
//             </Col>

//             <Col md={4}>
//               <Card className="service-card h-100" data-aos="zoom-in" data-aos-delay="100">
//                 <Card.Body>
//                   <FaCogs className="icon" />
//                   <Card.Title>Lifecycle Management</Card.Title>
//                   <Card.Text>
//                     Plan, manage, and transition IT assets with our complete lifecycle support services.
//                   </Card.Text>
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>

//           {/* Why Choose Us */}
//           <h4 className="fw-bold text-center mt-5 mb-4">Why Choose Our EOL Support?</h4>
//           <ul className="list-unstyled row check-list-lg justify-content-center">
//             <li className="col-md-4"><FaCheckCircle className="me-2 text-success" /> 20+ years of IT hardware expertise</li>
//             <li className="col-md-4"><FaCheckCircle className="me-2 text-success" /> Global network of trusted suppliers</li>
//             <li className="col-md-4"><FaCheckCircle className="me-2 text-success" /> Reduce costs without compromising performance</li>
//             <li className="col-md-4"><FaCheckCircle className="me-2 text-success" /> Fast, reliable delivery worldwide</li>
//             <li className="col-md-4"><FaCheckCircle className="me-2 text-success" /> Certified secure disposal processes</li>
//           </ul>

//           {/* CTA */}
//           <div className="text-center mt-5">
//             <Button variant="primary" href="/contact" className="cta-button">
//               Get EOL Hardware Support
//             </Button>
//           </div>
//         </Container>
//       </Container>
//     </div>
//   );
// };

// export default EndOfLifeHardwareSupport;




import React, {useEffect} from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { FaCheckCircle, FaServer, FaTools, FaTruck, FaShieldAlt, FaCogs, FaSyncAlt } from "react-icons/fa";
import "aos/dist/aos.css";
import "../styles/hardware.css"; // Using dedicated hardware styles

const EndOfLifeHardwareSupport = () => {
     useEffect(() => {
          window.scrollTo(0, 0); // <-- This forces scroll to top
        }, []);
  return (
    <div className="hardware-support-section">
      <Container fluid className="py-5 text-dark">
        <Container data-aos="fade-up">
          {/* Hero Section */}
          <Row className="align-items-center">
            <Col md={6} data-aos="fade-right">
              <h3 className="fw-bold mb-3">End-of-Life Hardware Support & Supply</h3>
              <p className="lead">
                Keep your mission-critical infrastructure running with our End-of-Life (EOL) hardware 
                support and supply services. We specialize in extending the lifespan of legacy IT systems 
                by providing expert maintenance, repair, and sourcing for discontinued servers, storage, 
                and networking equipment.
              </p>
              <ul className="list-unstyled check-list">
                <li><FaCheckCircle className="me-2 text-success" /> Global sourcing for rare & legacy components</li>
                <li><FaCheckCircle className="me-2 text-success" /> Expert repair & refurbishment services</li>
                <li><FaCheckCircle className="me-2 text-success" /> Cost-effective alternatives to full system upgrades</li>
              </ul>
            </Col>
            <Col md={6} data-aos="fade-left">
              <video
                src="/videos/hardware.mp4"
                className="hardware-video mt-4"
                autoPlay
                loop
                muted
                playsInline
              />
            </Col>
          </Row>

          {/* Key Services */}
          <h4 className="fw-bold text-center mt-5 mb-4">Our Key Services</h4>
          <Row className="g-4">
            <Col md={4}>
              <Card className="hardware-card h-100" data-aos="zoom-in">
                <Card.Body>
                  <FaServer className="icon" />
                  <Card.Title>Legacy Hardware Sourcing</Card.Title>
                  <Card.Text>
                    Access discontinued servers, storage devices, and networking hardware through our global supplier network.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="hardware-card h-100" data-aos="zoom-in" data-aos-delay="100">
                <Card.Body>
                  <FaTools className="icon" />
                  <Card.Title>Repair & Refurbishment</Card.Title>
                  <Card.Text>
                    Extend the lifespan of your infrastructure with professional repair, refurbishment, and part replacement.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="hardware-card h-100" data-aos="zoom-in" data-aos-delay="200">
                <Card.Body>
                  <FaTruck className="icon" />
                  <Card.Title>Fast Delivery</Card.Title>
                  <Card.Text>
                    Minimize downtime with rapid procurement and delivery of EOL components anywhere in the world.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="hardware-card h-100" data-aos="zoom-in">
                <Card.Body>
                  <FaShieldAlt className="icon" />
                  <Card.Title>Secure Asset Disposal</Card.Title>
                  <Card.Text>
                    Safely retire outdated hardware with certified data destruction and eco-friendly disposal practices.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="hardware-card h-100" data-aos="zoom-in" data-aos-delay="100">
                <Card.Body>
                  <FaCogs className="icon" />
                  <Card.Title>Lifecycle Management</Card.Title>
                  <Card.Text>
                    Plan, manage, and transition IT assets with our complete lifecycle support services.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            {/* NEW CARD */}
            <Col md={4}>
              <Card className="hardware-card h-100" data-aos="zoom-in" data-aos-delay="200">
                <Card.Body>
                  <FaSyncAlt className="icon" />
                  <Card.Title>Component Upgrade Solutions</Card.Title>
                  <Card.Text>
                    Upgrade and optimize critical hardware components without replacing entire systems, 
                    improving performance and extending asset life.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Why Choose Us */}
          <h4 className="fw-bold text-center mt-5 mb-4">Why Businesses Trust Our EOL Support</h4>
          <Row className="why-choose-cards g-4">
            <Col md={4} data-aos="fade-up">
              <Card className="why-card h-100">
                <Card.Body>
                  <FaCheckCircle className="icon text-success" />
                  <h5>Proven Expertise</h5>
                  <p>20+ years delivering mission-critical IT hardware solutions for global enterprises.</p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} data-aos="fade-up" data-aos-delay="100">
              <Card className="why-card h-100">
                <Card.Body>
                  <FaCheckCircle className="icon text-success" />
                  <h5>Global Supplier Network</h5>
                  <p>Access to rare components from trusted partners worldwide.</p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} data-aos="fade-up" data-aos-delay="200">
              <Card className="why-card h-100">
                <Card.Body>
                  <FaCheckCircle className="icon text-success" />
                  <h5>Cost Optimization</h5>
                  <p>Save on infrastructure costs without compromising system performance.</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* CTA */}
          <div className="text-center mt-5">
            <Button variant="primary" href="/contact" className="cta-button">
              Get EOL Hardware Support
            </Button>
          </div>
        </Container>
      </Container>
    </div>
  );
};

export default EndOfLifeHardwareSupport;
